import { lightColorPalette } from '@linearb/linui-common';
import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

export const StyledSeparator = styled.div`
  box-sizing: border-box;
  width: 1px;
  height: 60%;
  border: 1px solid ${lightColorPalette.lbBlue_20};
  margin: 0 1rem;
`;

export const StyledFilterSetDueDate = styled.div`
  color: ${getColor('shuttleGray')};
  margin-top: 0.1rem;
  text-transform: uppercase;
`;

export const StyledFilterSetOptions = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledFilterSetHeader = styled.header`
  height: 3rem;
  padding: 0 1rem;
  display: flex;
  align-items: center;
`;
